import {
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { HealthCheckService } from '../shared/service/health-check.service';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  constructor(private healthCheckService: HealthCheckService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 500) {
          console.error('Error 500 detected:', error);
          this.healthCheckService.checkBackend();
        }
        return throwError(() => error);
      }),
    );
  }
}

export const serverInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: ServerErrorInterceptor,
  multi: true,
};
